module.exports = function() {
  return new Worker(__webpack_public_path__ + "9259df164fab353b4303.worker.js");
};